export default (theme) => ({

    galleryEditorPage: {
        backgroundColor: "#ededed",
        width: "100%"
    },
    gallery_editor_container: {
        marginLeft: "60px",
        marginRight: "30px",
        marginBottom: "30px",
        marginTop:'0px',
        paddingRight:'10px',
        paddingLeft:'60px',
        paddingTop:'10px',
        backgroundColor: "white",
        position:'relative',
        top:'0%',
    },
    background: {
        width: "100%",
        height: "100%",
    },
    saving: {
        position: "fixed",
        width: "100%",
        height: "100%",
    },
    editGalleryBackground: {
        backgroundColor: "#0c59cf",
        width: "100%",
        height: "100%",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
        background: "rgba(0, 0, 0, 0.09)",
        borderRadius: 20,
        margin: 2,
    },
    middlebar: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    },
    headertitle: {
        color: "white",
        fontFamily: "Helvetica",
        fontSize: "40px !important",
    },
    largepaper: {
        display: "flex",
        width: "50%",
        height: 32,
        background: "rgba(0, 0, 0, 0.09)",
        borderRadius: 20,
        margin: 2,
    },
    smallpaper: {
        display: "flex",
        height: 32,
        background: "rgba(0, 0, 0, 0.09)",
        borderRadius: 20,
        margin: 2,
    },
    maptypography: {
        width: "90%",
        fontSize: "18px !important",
        fontWeight: "500",
        wordSpacing: 7,
        padding: 1,
    },
    smalltypography: {
        width: "30%",
        fontSize: "18px !important",
        fontWeight: "500",
        wordSpacing: 7,
        padding: 1,
    },
    modalPaper: {
        position: "absolute",
        width: "35%",
        border: "2px solid #000",
        borderRadius: 20,
        boxShadow: theme.shadows[5],
    },
    laptopModalPaper: {
        position: "absolute",
        width: "40%",
        border: "2px solid #000",
        borderRadius: 20,
        boxShadow: theme.shadows[5],
    },
    ipadModalPaper: {
        position: "absolute",
        width: "55%",
        border: "2px solid #000",
        borderRadius: 20,
        boxShadow: theme.shadows[5],
    },
    middleModalPaper: {
        position: "absolute",
        width: "50%",
        border: "2px solid #000",
        borderRadius: 20,
        boxShadow: theme.shadows[5],
    },
    modalMapPaper: {
        position: "absolute",
        width: "80%",
        marginLeft: "10%",
    },
    editGalleryMapModal: {
        position: "absolute",
        width: "65%",
        top: `15%`,
        left: `34%`,
        transform: `translate(-37%, -15%)`,
    },
    btnWrapper: {
        display: "flex",
        height: 80,
        width: "100%",
        padding: 5,
        zIndex: 99,
        justifyContent: "center",
    },
    largeColorBtn: {
        width: "100%",
        backgroundColor: "white !important",
        color: "black",
        fontSize: "18px",
        textTransform: "capitalize",
        fontWeight: "500",
    },
    normalWhiteBtn: {
        width: 200,
        height: 50,
        backgroundColor: "white !important",
        color: "blue",
        borderRadius: 20,
        border: "1px solid",
        textTransform: "capitalize",
        borderColor: "black",
    },
    setFolderWrapper: {
        padding: 20,
        display: "flex",
        flexDirection: "column",
        zIndex: 99,
    },
    setPriceWrapper: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        borderRadius: 20,
        position: "relative",
        background:
            " linear-gradient(to right, rgb(170, 255, 251) 1%, rgb(1, 132, 255) 100%)",
    },
    multiPreviewer: {
        width: "50%",
        display: "flex",
        justifyContent: "space-around",
    },
    progressWrapper: {
        width: "100%",
        height: "200px",
    },

    /////////////////////////////////////

    grid: {
        display: "flex",
        justifyContent: "center",
        alignItems: "left",
        flexDirection: "column",
        paddingBottom: 25,
        paddingRight:0,
        paddingTop: 0,
        height: "100%",
    },
    grid1:{
        marginLeft:'90px'
    },
    grid2: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        flexDirection: "column",
        padding: 25,
        paddingTop: 0,
        height: "100%",
    },

    textField: {
        width: "80%",
    },
    drop: {
        width: "100%",
    },
    grayDrop: {
        color:'#A2A2A2 !important',
        width: "100%",
    },
    placeHolderSize:{
        fontSize: '180px !important',
        fontWeight: '600 !important',

    },
    smallTextField: {
        width: "25%",
    },
    typography: {
        color: "#0c59cf",
        fontSize: "15px !important",
        fontWeight: "600",
        width: "90%",
        marginTop: 10,
        
    },
   
    typographyMain: {
        color: "#0c59cf",
        fontSize: "15px !important",
        fontWeight: "600",
        width: "90%",
        marginTop: 10,
        display:'flex',
        alignItems:'center',
        '& p':{
            paddingRight:'10px'
        }
        
    },
    buttontypography: {
        color: "#0c59cf",
        fontSize: "16px !important",
        fontWeight: "500",
        padding: 2,
    },
    greenbuttontyopgraphy: {
        color: "white",
        fontSize: "16px !important",
        fontWeight: "500",
        padding: 2,
    },
    titletypography: {
        color: "#0c59cf",
        fontSize: "16px !important",
        fontWeight: "500",
        width: "100%",
        top:'0%',
        transform:'translateY(-130%)',
        position:'relative'
    },
    editGalleryTypography: {
        color: "#0c59cf",
        fontSize: "16px !important",
        fontWeight: "500",
        width: "85%",
        padding: 8,
    },
    pricingtypography: {
        color: "black",
        fontSize: "16px !important",
        fontWeight: "500",
        padding: 8,
    },
    button: {
        backgroundColor: "#cfcfcf !important",
        color: "#0c59cf",
        boxShadow: "2px 4px 10px rgba(0, 0, 0, 0.69)",
        borderRadius: 5,
        textTransform: "capitalize",
        width: "95%",
        textAlign: "left",
        marginTop: 25,
    },
    greenbutton: {
        backgroundColor: "green !important",
        color: "white",
        boxShadow: "2px 4px 10px rgba(0, 0, 0, 0.69)",
        borderRadius: 5,
        textTransform: "capitalize",
        width: "95%",
        textAlign: "left",
        marginTop: 25,
    },
    justifyElement: {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        color: "black",
    },
    icon: {
        color: "black",
        width: 25,
        height: 25,
        
    },
    whiteicon: {
        color: "white",
        width: 25,
        height: 25,
    },
    largeBlueBtn: {
        width: "30%",
        backgroundColor: "#0c59cf !important",
        boxShadow: "0px 5px 10px rgba(248, 95, 106, 0.23)",
        color: "white",
        textTransform: "inherit",
        fontSize: "16px !important",
        fontWeight: "600",
        margin: 6,
        padding: 12,
        marginTop: 25,
    },
    largeGrayBtn: {
        width: "30%",
        backgroundColor: "gray !important",
        color: "white",
        opacity:'0.7',
        textTransform: "inherit",
        fontSize: "16px !important",
        fontWeight: "600",
        margin: 6,
        padding: 12,
        marginTop: 25,
    },
    largeGreenBtn: {
        width: "30%",
        backgroundColor: "gray !important",
        boxShadow: "0px 5px 10px rgba(248, 95, 106, 0.23)",
        color: "white",
        textTransform: "inherit",
        fontSize: "16px !important",
        fontWeight: "600",
        margin: 6,
        padding: 12,
        marginTop: 25,
    },
    submitAndCancelBtn:{
        display:'flex',
        justifyContent:'space-evenly',
        width:'90%'
    },
    spaceTop:{
        marginTop:'50px'
    },
    icon: {
        color: "black",
        width: 25,
        height: 25,
        
    },
    loadGalleryTitle: {
        fontFamily: "Quicksand",
        fontSize: 30,
        color: "#35424a",
        textAlign: "center",
    },
    editGalleryTitle: {
        fontFamily: "Quicksand",
        fontSize: 30,
        color: "#35424a"
    },
    editGalleryName: {
        fontFamily: "Quicksand",
        fontSize: 25,
        color: "#929292",
    },
    textwrapper: {
        display: "flex",
        padding: 30,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        borderRadius: 30,
        margin: 5,
        color: "black",
        width: "75%",
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },

    chip: {
        marginTop: -5,
        marginBottom: -5,
        marginRight: 2,
        marginLeft: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
    GalleryTypeRadioGroup: {
        width: "600px",
        paddingBottom: '10px',
    },
});
